// Array of field configurations
import { FormField } from "./Types";

// Array of field configurations
export const formFields: FormField[] = [
    /* {
        label: "description",
        name: "product_description",
        type: "textarea",

        required: "Type is required",
    }, */
    {
        label: "Available Stock",
        name: "available_stock",
        type: "number",
        required: "Available Stock is required",
    },
    {
        label: "Product Price",
        name: "product_price",
        type: "number",
        required: "Price is required",
        validate: (value) => {
            const numericValue = Number(value); // Convert string to number
            return numericValue > 0 || "Price must be greater than 0";
        },
    },

    {
        label: "SKU CODE",
        name: "sku",
        type: "text",
        required: "SKU Code is required",
    },
];

export const breadcrumbItems = [{ label: "Products", link: "/auth/products" }];
